'use client'

import Button from '@/components/ui/Button'
import { useProductSelection } from '@/contexts/ProductSelectionContext'
import { useState } from 'react'
import ContactFormModal from '@/components/ContactFormModal'
import { FaPlus, FaMinus, FaEnvelope } from 'react-icons/fa'

interface ProductInterestButtonProps {
  product: {
    id: string
    name: string
    slug: string
    category_id: string | null
  }
}

export default function ProductInterestButton({ product }: ProductInterestButtonProps) {
  const { addProduct, removeProduct, isSelected, count } = useProductSelection()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const selected = isSelected(product.id)

  const handleToggleInterest = () => {
    if (selected) {
      removeProduct(product.id)
    } else {
      addProduct(product)
    }
  }

  const handleOpenContact = () => {
    if (!selected) {
      addProduct(product)
    }
    setIsModalOpen(true)
  }

  return (
    <>
      <div className="flex gap-3 mt-8">
        <Button
          onClick={handleToggleInterest}
          variant={selected ? 'outline' : 'default'}
          className={`flex items-center gap-2 ${
            selected 
              ? 'bg-primary-50 border-primary-300 text-primary-700 hover:bg-primary-100' 
              : ''
          }`}
        >
          {selected ? (
            <>
              <FaMinus />
              Kaldır
            </>
          ) : (
            <>
              <FaPlus />
              Ekle
            </>
          )}
        </Button>
        
        <Button
          onClick={handleOpenContact}
          className="flex items-center gap-2 flex-1"
        >
          <FaEnvelope />
          Bilgi Al
          {count > 0 && (
            <span className="bg-white text-primary-600 rounded-full px-2 py-0.5 text-xs font-bold">
              {count}
            </span>
          )}
        </Button>
      </div>
      
      <ContactFormModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </>
  )
}

